import { _breakP } from './utils.js';

/**
 * BEM 任意レイアウト + .js-acod / .js-acodBtn / .js-acodBody
 * （任意）.js-acodLabel … acodDisable 時の aria-label はこの要素のテキストのみ（画像 alt を含めない）
 * id・ARIA は JS 付与。data-only-device 対応
 */
export default class acod {
  constructor() {
    this.acodFunc();
  }

  acodFunc() {
    const $acod = document.querySelectorAll('.js-acod');

    if ($acod.length) {
      $acod.forEach((elm, index) => {
        const $acodBtn = elm.querySelector('.js-acodBtn'),
          $acodBody = elm.querySelector('.js-acodBody');

        if (!$acodBtn || !$acodBody) return;

        $acodBtn.setAttribute('aria-controls', `acod-${index}`);
        $acodBtn.setAttribute('aria-expanded', 'false');

        $acodBody.setAttribute('aria-hidden', 'true');
        $acodBody.setAttribute('id', `acod-${index}`);

        const acodToggle = () => {
          $acodBtn.removeAttribute('tabindex');
          $acodBtn.style.pointerEvents = '';
          $acodBtn.removeAttribute('aria-label');

          $acodBtn.addEventListener('click', () => {
            $acodBtn.classList.toggle('is-active');
            $acodBody.classList.toggle('is-active');
            if ($acodBtn.getAttribute('aria-expanded') === 'true') {
              $acodBtn.setAttribute('aria-expanded', 'false');
            } else {
              $acodBtn.setAttribute('aria-expanded', 'true');
            }
            if ($acodBody.getAttribute('aria-hidden') === 'true') {
              $acodBody.setAttribute('aria-hidden', 'false');
            } else {
              $acodBody.setAttribute('aria-hidden', 'true');
            }
          });
        };

        const acodDisable = () => {
          const $labelSrc = $acodBtn.querySelector('.js-acodLabel');
          const labelText = ($labelSrc ?? $acodBtn).textContent.trim();
          $acodBtn.setAttribute('tabindex', '-1');
          $acodBtn.setAttribute('aria-label', labelText);
          $acodBtn.style.pointerEvents = 'none';
          $acodBtn.setAttribute('aria-expanded', 'true');
          $acodBody.setAttribute('aria-hidden', 'false');
          $acodBtn.classList.add('is-active');
          $acodBody.classList.add('is-active');
        };

        if (elm.dataset.onlyDevice === 'sp') {
          _breakP.SP ? acodToggle() : acodDisable();
        } else if (elm.dataset.onlyDevice === 'pc') {
          !_breakP.SP ? acodToggle() : acodDisable();
        } else {
          acodToggle();
        }
      });
    }
  }
}
